import { useUpdateGoal } from 'features/goals';
import { useCallback } from 'react';
import { rootId } from 'shared/components/ui/virtualized-tree-list';
import { Goal, UpdateGoal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export const useGoalTreeReorder = (goal: Goal) => {
  const { submit: updateGoal } = useUpdateGoal();

  return useCallback(
    (
      updatedSections: { id: ID; goalSorting: ID[] }[],
      updatedGoals: UpdateGoal[],
    ) => {
      updatedGoals.forEach((goalUpdate) =>
        updateGoal({
          ...goalUpdate,
          parentIds: goalUpdate.parentIds ?? [
            ...(goal.parentIds ?? []),
            goal.id,
          ],
        }),
      );

      updatedSections.forEach(({ id, goalSorting }) => {
        if (id === rootId) {
          updateGoal({ id: goal.id, goalSorting });
          return;
        }
        // there should be nothing here
      });
    },
    [goal.id, goal.parentIds, updateGoal],
  );
};
